import PageLayout from '@frolight/components/PageLayout';
import TableOfContents from '@frolight/components/TableOfContents';
import usePageTitle from '@frolight/hooks/usePageTitle';
import Panel from '@frolight/components/Panel';
import useFormattedLocalizedText from '@frolight/hooks/useLocalizedFormattedText';

const CookiePolicy = () => {
  const { lftext } = useFormattedLocalizedText();

  const title = lftext('pages.cookie_policy.title');

  usePageTitle(title);


  return (
    <PageLayout>
      <Panel
        size="huge"
        title={ <h1>{ title }</h1> }
      >
        <main>
          <p>
            { lftext('pages.cookie_policy.effective_as_of') }
          </p>
          <TableOfContents >
            <div>
              {lftext('pages.cookie_policy.content')}
            </div>
          </TableOfContents>
        </main>
      </Panel>
    </PageLayout>
  );

}

export default CookiePolicy;